import { stripMask } from "./parse";

export function formatCpf(value: string): string {
  const d = stripMask(value).slice(0, 11);
  return d
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2");
}

export function formatCnpj(value: string): string {
  const d = stripMask(value).slice(0, 14);
  return d
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
}

export function formatPhone(value: string): string {
  const d = stripMask(value).slice(0, 11);
  if (d.length <= 10) {
    return d.replace(/^(\d{2})(\d)/, "($1) $2").replace(/(\d{4})(\d)/, "$1-$2");
  }
  return d.replace(/^(\d{2})(\d)/, "($1) $2").replace(/(\d{5})(\d)/, "$1-$2");
}

export function formatCep(value: string): string {
  const d = stripMask(value).slice(0, 8);
  return d.replace(/^(\d{5})(\d)/, "$1-$2");
}

export function formatCurrency(
  value: number,
  options: { currency?: string; locale?: string } = {}
): string {
  if (!Number.isFinite(value)) return "";
  const { currency = "BRL", locale = "pt-BR" } = options;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

/** Máscara digitada: "1234" → "R$ 12,34". Usa os dígitos como centavos. */
export function maskCurrencyInput(value: string): string {
  const digits = stripMask(value);
  if (!digits) return "";
  return formatCurrency(Number(digits) / 100);
}
